import React, { useContext, useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../App";
import SimulatorHeader from "../../components/simulator-header/SimulatorHeader";
import axios from "axios";
import styles from "./Home.styles.scss";

import { Tag } from '../../components/tag/Tag'
import { AiFillStar } from 'react-icons/ai'
import { Badge } from "../../components/badge/Badge";
import { FeaturedTag } from "../../components/featuredTag/FeaturedTag";
import TagManager from 'react-gtm-module';
const Home = () => {
    const { environment, setEnvironment, setStep, isTotem } = useContext(
        UserContext
    );
    const navigate = useNavigate();

    const [environments, setEnvironments] = useState([]);

    const setEnv = (environment) => {
        setEnvironment(environment);
        const totemInfo = isTotem ? "totem_" : "";
    
        const event = {
            event: 'click',
            eventCategory: 'click',
            eventAction: totemInfo + `simulador_passo_01_click_${environment.slug}`
        };

    
    
        TagManager.dataLayer({ dataLayer: event });
    
        navigate(`/${environment.slug}/opcao-de-ambiente`);
    };

    const hasOptionYOU = useCallback((env) => {
        return env.environment_options.find(option => option.has_duratex_you_patterns === true)
    }, []);

    useEffect(() => {
        axios
            .get(`${MIX_URL}/simulator-api/environments`)
            .then((response) => {
                setEnvironments(response.data.environments);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    useEffect(() => {
        setStep(1);
    }, [])

    return (
        <div className={`home-page ${isTotem ? "totem" : ""}`}>
            <div className="container m-auto">
                <SimulatorHeader
                    title="1. Escolha um ambiente para simular"
                    nextHidden
                />
                <div className="templates grid grid-cols-2 md:grid-cols-3 gap-32 pb-356">
                    {environments &&
                        environments.map((env) => (
                            <a
                                key={env.slug}
                                className={"bg-white flex flex-col space-y-10 content-center items-center cursor-pointer group py-24"}
                                onClick={() => setEnv(env)}
                            >
                                <div className="flex flex-col items-center">
                                    <img
                                        src={`${MIX_AWS_URL}/${env.image}`}
                                        className="w-94 h-96 group-hover:scale-125 transition-all duration-300"
                                    />
                                    <span className="block text-center text-24 text-gray90 font-light">
                                        {env.name}
                                    </span>
                                    <p className="text-gray90 text-12">
                                        {env.environment_options.length} ambientes
                                        disponíveis
                                    </p>
                                </div>
                                <div className="flex flex-col w-full space-y-8 relative">
                                    <Tag label="Portfólio Duratex" />
                                    {
                                        hasOptionYOU(env) && <FeaturedTag label="Duratex YOU" />
                                    }
                                </div>
                            </a>
                        ))}
                </div>
            </div>
        </div>
    );
};

export default Home;
